import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        width: "100%",
        height: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        background: theme.palette.primary.main,
    },
    titleContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    title: {
        color: theme.palette.info.main,
        fontWeight: "600 !important",
    },
    infoContainer: {
        padding: `0 ${theme.spacing(6)}`,
    },

    graphContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        marginTop: theme.spacing(5),
    },
    graphGridItemContainer: {
        display: "flex",
        position: "relative",
        height: "50vh !important",
        "@media (min-width: 1600px)": {
            height: "40vh !important",
        },
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
}));
